import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function GuaranteeSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-140" data-mp="4vryttha25or">
      <div className="mx-auto max-w-2xl text-center" data-id="element-141" data-mp="9u3b0av1osa5">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-[6px] border-gold-400 bg-navy-900 text-white" data-id="element-142" data-mp="9wfr0ih8sskk">
          <ShieldCheckIcon className="h-9 w-9 text-gold-400" aria-hidden="true" data-id="element-143" data-mp="jtbxyjrht6n0" />
          <span className="font-display text-xl font-black uppercase leading-none" data-id="element-144" data-mp="ntm5i0uxo53z">7 days</span>
        </div>
        <p className="mt-6 font-display text-lg font-bold uppercase tracking-wider text-electric-600" data-id="element-145" data-mp="skknr5zhfd9v">My 7-day guarantee</p>
        <h2 className="mt-1 font-display text-[38px] font-extrabold uppercase leading-[0.98] text-ink sm:text-5xl" data-id="element-146" data-mp="xim9jyoalqp1">
          Try TCM Diagnostic Blueprint™ <span className="text-cta-700" data-id="element-147" data-mp="17i4q054zuucc">risk-free</span>
        </h2>
        <div className="mt-6 space-y-4 text-left text-[17px] leading-relaxed text-muted sm:text-center" data-id="element-148" data-mp="17id1bslgxrlf">
          <p className="font-semibold text-ink" data-id="element-149" data-mp="25pu8xaeutkgj">I don't want you buying this because of hype. I want you to open it.</p>
          <p data-id="element-150" data-mp="1vtr9icbdzzxa">
            Explore the decision maps. Review the troubleshooting routes. Print the checklists. Use the documentation
            templates. See whether the system fits the way you work.
          </p>
          <p data-id="element-151" data-mp="2oi55kmix0m67">
            If, within seven days of your purchase, you decide that TCM Diagnostic Blueprint™ isn't right for your
            workflow, you can request a refund according to the applicable refund terms.
          </p>
          <p data-id="element-152" data-mp="2erakhlhensmc">
            No subscription. No long-term commitment. Just an opportunity to evaluate the product and decide whether it
            provides value to you.
          </p>
        </div>
        <CtaButton label="Try it for 7 days" className="mt-10" data-id="element-153" data-mp="379xy6fu2o5de" />
      </div>
    </section>;
}